





















import UserModule from '@/store/modules/user';
import axios from 'axios';
import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
@Component({})
export default class extends Vue {
  @Prop() showPoliticalOutlookPicker: boolean;
  @Watch('showPoliticalOutlookPicker', { deep: true, immediate: true })
  async ShowPoliticalOutlookPicker(val: boolean) {
    this.show = val;
  }
  show: boolean = false;
  columns = [];
  onConfirm(val: string) {
    this.$emit('politicalOutlookConfirm', val);
  }
  onCancel() {
    this.$emit('politicalOutlookCancel');
  }

  sortBy(i) {
    return function(a, b) {
      return a[i] - b[i];
    };
  }

  async getPoliticalOutlook() {
    await apiAxios
      .get('/api/Standard/GetItemFromCode?code=PoliticalOutlook', axiosOptions)
      .then(res => {
        if (res) {
          this.columns = res.data.data.sort(this.sortBy('order'));
        }
      })
      .catch(err => {
        console.log('err:', err);
      });
  }

  mounted() {
    this.getPoliticalOutlook();
  }
}

export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
